import type { ISchoolLastActionResponse } from "@/providers/store/api/schools/schools.interface";
import { formatDateMMDDYYYY } from "@/shared/utils/format-date.util";

export interface ScheduledActionDisplayItem {
  type: "text";
  head: string;
  value: string;
}

/**
 * Returns a display item for a scheduled OPENED/CLOSED action if the action date is in the future.
 * Otherwise returns null.
 */
export function getScheduledActionDisplayItem(
  featureAction: ISchoolLastActionResponse,
): ScheduledActionDisplayItem | null {
  const dateStr = featureAction.payload?.date;

  if (!dateStr) return null;

  const actionDate = new Date(dateStr);

  if (Number.isNaN(actionDate.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  actionDate.setHours(0, 0, 0, 0);

  if (actionDate.getTime() <= today.getTime()) return null;

  const headByType: Record<string, string> = {
    OPENED: "Scheduled Opening Date",
    CLOSED: "Scheduled Closing Date",
  };

  const head = headByType[featureAction.actionType] ?? "Scheduled Date";

  return {
    type: "text" as const,
    head,
    value: formatDateMMDDYYYY(dateStr),
  };
}
